import Edit from "./Edit";
import FilesList from "./FilesList";
import ErrorDescription from "./ErrorDescription";

export default {
    Edit,
    FilesList,
    ErrorDescription
}